namespace $.$$ {

	$mol_style_define( $shm_ba_dashboard, {
		width: '100%',
		minHeight: '100%',

		Report_page: {
			flex: {
				grow: 1,
				shrink: 1,
				basis: '720px',
			},
			Head: {
				flex: {
					wrap: 'wrap',
				},
			},
			Tools: {
				align: {
					items: 'center',
				},
			},
			Title: {
				align: {
					items: 'center',
				},
				gap: '0.5rem',
				padding: 0,
				minWidth: 0,
				flex: {
					wrap: 'nowrap',
					shrink: 1,
				},
			},
			minWidth: '520px',
		},

		Logo: {
			flex: {
				grow: 0,
				shrink: 0,
			},
		},

		Report_tabs: {
			display: 'flex',
			alignItems: 'center',
			flexWrap: 'wrap',
			gap: '2px',
			minWidth: 0,
			flex: {
				shrink: 1,
				grow: 1,
				basis: 0,
			},
		},

		Report_tab: {
			display: 'flex',
			alignItems: 'center',
			minWidth: 0,
			maxWidth: '18rem',
			':hover': {
				['Report_actions' as '$mol_view']: {
					opacity: 1,
					pointerEvents: 'auto',
				},
			},
			':focus-within': {
				['Report_actions' as '$mol_view']: {
					opacity: 1,
					pointerEvents: 'auto',
				},
			},
		},

		Report_link: {
			minHeight: 0,
			minWidth: 0,
			maxWidth: '16rem',
			paddingRight: '0.25rem',
		},

		Report_actions: {
			opacity: 0,
			pointerEvents: 'none',
			flex: {
				grow: 0,
				shrink: 0,
			},
			'[settings_opened]': {
				true: {
					opacity: 1,
					pointerEvents: 'auto',
				},
			},
		},

		File_label: {
			padding: {
				left: '1rem',
			},
			color: $mol_theme.shade,
			font: {
				size: '13px',
			},
		},

		Report_settings: {
			width: '1.5rem',
			Trigger: {
				minWidth: '1.5rem',
				// minWidth: '32px',
				// minHeight: '32px',
				justifyContent: 'center',
				padding: 0,
				paddingRight: '0.75rem',
			},
		},

		Report_settings_content: {
			flexDirection: 'column',
			gap: '8px',
			padding: '8px',
			minWidth: '16rem',
		},

		Report_title_input: {
			width: '100%',
		},

		Report_delete: {
			color: '#ff6666',
			justifyContent: 'flex-start',
		},

		Report_delete_text: {
			minWidth: '8rem',
		},

		Report_delete_yes: {
			justifyContent: 'flex-start',
			padding: {
				left: '12px',
				right: '12px',
			},
		},

		Report_delete_no: {
			justifyContent: 'flex-start',
			padding: {
				left: '12px',
				right: '12px',
			},
		},

		Empty: {
			color: $mol_theme.shade,
			padding: {
				top: $mol_gap.block,
				bottom: $mol_gap.block,
			},
		},

		Summary_data: {
			position: 'relative',
			flexDirection: 'column',
			gap: '12px',
		},

		Summary_loading: {
			position: 'absolute',
			inset: '0',
			zIndex: 1,
			alignItems: 'center',
			justifyContent: 'center',
			color: $mol_theme.shade,
			background: {
				color: `color-mix( in srgb, ${ $mol_theme.back } 80%, transparent )` as any,
			},
		},

		Summary_loading_content: {
			flexDirection: 'column',
			alignItems: 'center',
			gap: '0.75rem',
			padding: $mol_gap.block,
			textAlign: 'center',
		},

	} )

}
